export const PROPERTY_DEACTIVATED_REASONS = {
  PAYMENT_FAILURE: 'payment_failure',
};

export const PROPERTY_STATUS = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
};

export default {
  PROPERTY_STATUS,
  PROPERTY_DEACTIVATED_REASONS,
};
